module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wokVq/tc-custom/9783987448591.jpg?1704425250741",
      "alt": "This image is the cover for the book Troubled Star, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Troubled Star, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("An advanced alien race is considering our sun as a reference point on their star route, but must first determine if there are any intelligent life-forms in its solar system, since altering the sun would be fatal for all the system's life. The aliens seek to contact the most highly-regarded being on planet Earth, coming up with Dusty Britton  of the Space Patrol. What they DON'T realize is that he's an actor, star of a hit sci-fi  TV show! Egotistical Dusty quickly realizes that he must now play his TV role in real life in order to save the solar system from disaster. An excellent mix of space opera, humor, and suspense! (Goodreads)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George O. Smith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("George Oliver Smith (April 9, 1911 – May 27, 1981) (also known by the pseudonym Wesley Long) was an American science fiction author. Smith was an active contributor to Astounding Science Fiction during the Golden Age of Science Fiction in the 1940s. His collaboration with the magazine's editor, John W. Campbell, Jr. was interrupted when Campbell's first wife, Doña, left him in 1949 and married Smith. Smith continued regularly publishing science fiction novels and stories until 1960. His output greatly diminished in the 1960s and 1970s when he had a job that required his undivided attention. He was given the First Fandom Hall of Fame award in 1980. He was a member of the all-male literary banqueting club the Trap Door Spiders, which served as the basis of Isaac Asimov's fictional group of mystery solvers the Black Widowers.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0